function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.7 283.7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.1 148.7v57h14.5v-42.5h95.6v42.4h14.5v-42.4h88.1v42.5h14.5v-57zM130.4 283.5l36.1-44.2h-21.3l7.8-26.6-36.1 44.3h21.2zM119.1 141.6l72.2-88.4h-42.6L164.3 0 92.1 88.6h42.4zM20.3 283.5l36.1-44.2H35.1l7.8-26.6L6.8 257H28zM233.5 283.5l36.1-44.2h-21.3l7.8-26.6L220 257h21.2z"
})));